export default function deleteCookiesApi() {
  // Setting WC_ Cookies new value on 401
  fetch('/wcs/resources/store/301/guestidentity/@self?updateCookies=true', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
